export const SLIDE_INC = 'SLIDE_INC';
export const SLIDE_DEC = 'SLIDE_DEC';
export const SLIDE_TYPE = 'SLIDE_TYPE';
export const START = 'START';
export const END = 'END';